export const getCollisionFallbackDirRelative = (
	pageId: string,
	newSlug: string,
	targetDirRelative?: string
): string => {
	const shortId = pageId.substring(0, 8);
	return targetDirRelative ? `${targetDirRelative}-${shortId}` : `pages/${newSlug}-${shortId}`;
};
